export default "__VITE_ASSET__Bq1sVayh__"